// Default AppBar layout render helper (lint split).
import { AppBar, Toolbar, Box } from '@mui/material';
import {
  renderAppBarAccountMenu,
  renderAppBarBattlefieldActions,
  renderAppBarLogo,
  renderAppBarQuickFilterRow,
} from '@/components/layout/appBarHeaderShared';
import { AppBarNav } from '@/components/layout/appBarHeaderNavMenu';

export function renderDefaultAppBar({
  isDesktop,
  tab,
  visiblePages,
  onTabChange,
  t,
  logoAlt,
  isBattlefield,
  hasFilter,
  inboxCount,
  onOpenFilter,
  onOpenInbox,
  initials,
  avatarAnchor,
  setAvatarAnchor,
  onLogout,
  onOpenHelp,
  onOpenSettings,
  accountMenuTriggerRef,
  helpLabel,
  hideQuickFilters = false,
}) {
  const accountMenuLabel = t('appbar.accountMenu', 'Account menu');
  const settingsLabel = t('settings.menuItem', 'Settings');
  const logoutLabel = t('appbar.logout');
  const feedbackLabel = t('appbar.feedback');

  return (
    <>
      <AppBar
        position="sticky"
        color="inherit"
        elevation={0}
        sx={{ borderBottom: 1, borderColor: 'divider' }}
      >
        <Toolbar variant="dense" sx={{ gap: 2 }}>
          {renderAppBarLogo(logoAlt)}
          <AppBarNav
            isDesktop={isDesktop}
            tab={tab}
            visiblePages={visiblePages}
            onTabChange={onTabChange}
            t={t}
          />
          <Box
            sx={{
              ml: 'auto',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            {isBattlefield
              ? renderAppBarBattlefieldActions({
                  hasFilter,
                  inboxCount,
                  onOpenFilter,
                  onOpenInbox,
                  filterLabel: t('appbar.filter'),
                  inboxLabel: t('appbar.inbox'),
                  showFilter: !hideQuickFilters,
                })
              : null}
            {renderAppBarAccountMenu({
              initials,
              avatarAnchor,
              setAvatarAnchor,
              onLogout,
              onOpenHelp,
              onOpenSettings,
              accountMenuTriggerRef,
              accountMenuLabel,
              settingsLabel,
              helpLabel,
              logoutLabel,
              feedbackLabel,
            })}
          </Box>
        </Toolbar>
      </AppBar>
      {!isBattlefield && !hideQuickFilters
        ? renderAppBarQuickFilterRow({
            p: '10px 16px',
            borderBottom: 1,
            borderColor: 'divider',
            bgcolor: 'background.paper',
          })
        : null}
    </>
  );
}
